import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MainService } from 'app/resources/services/index';
import { DefineBootboxId } from 'app/resources/classes';

@Component({
  selector: 'app-anexos',
  templateUrl: './anexos.component.html',
  styleUrls: ['./anexos.component.css']
})
export class AnexosComponent implements OnInit {

  public bootboxAlertComId: DefineBootboxId = new DefineBootboxId();
  public processando = false;
  public anexo: any;
  public hideModal: boolean;

  constructor(public mainService: MainService, public router: Router) { }

  ngOnInit() {
    this.anexo = {};
    this.mainService.saldoService.initialize();
  }

  public saveAnexo() {
    if (this.anexo.arquivo !== undefined) {
      this.processando = true;
      this.mainService.http.pathRest().post('cartao/current/chamado/' +
        this.mainService.sacService.chamadoSelecionado.id + '/' + this.mainService.sacService.chamadoSelecionado.uuid +
        '/anexo/', { anexo: this.anexo }, true)
        .subscribe(
        sucesso => {
          this.mainService.sacService.visualizarAnexos(this.mainService.sacService.chamadoSelecionado);
          this.processando = false;
        });
    } else {
      this.bootboxAlertComId.alerta('Selecione o arquivo que será anexado');
    }
  };

  public removeAnexo(anexo) {
    const that = this;

    const mensagem = bootbox.confirm({
      message: 'Deseja excluir o anexo?',
      buttons: {
        confirm: {
          label: 'Sim',
          className: 'btn-danger'
        },
        cancel: {
          label: 'Não',
          className: 'app-btn-best'
        }
      },
      callback: function (result) {
        if (result) {
          that.mainService.http.pathRest().delete('chamado/anexo/' + anexo.id + '/' + anexo.uuid + '/', true)
            .subscribe(
            sucesso => {
              that.mainService.sacService.visualizarAnexos(that.mainService.sacService.chamadoSelecionado);
            });
        }
      }
    });

    mensagem.on('shown.bs.modal', function () {
      $('button[data-bb-handler="cancel"]').attr('id', 'btn-bootbox-cancel');
      $('button[data-bb-handler="confirm"]').attr('id', 'btn-bootbox-confirm');
      $('button[class="bootbox-close-button close"]').attr('id', 'btn-bootbox-close');
      $('div[class="bootbox-body"]').attr('id', 'div-bootbox-body');
    });
  }

  public formatFile(event) {
    try {
      const file: File = event.target.files[0];
      const reader: FileReader = new FileReader();
      reader.onload = (valor) => {
        this.anexo = { 'arquivo': reader.result.split(',')[1], 'tipo': file.type, 'nome': file.name };
      };
      reader.readAsDataURL(file);
    } catch (erro) {

    }
  }

}



// WEBPACK FOOTER //
// ./src/app/menu-superior/sac/anexos/anexos.component.ts